import type { ValidationCase } from '../types/barcodeValidation';

/**
 * 9 sample barcode cases from docs/Validacao_GS1_Excel/codigos_barras_oficial
 * Images served from /barcode-samples/
 */
export const SAMPLE_BARCODE_CASES: ValidationCase[] = [
  {
    id: 'sample-1',
    name: '1 - DataMatrix (pequeno)',
    createdAt: '2026-02-24T14:18:00.000Z',
    updatedAt: '2026-02-24T14:18:00.000Z',
    photos: [{ id: 'photo-s1', dataUrl: '/barcode-samples/codigo_barras_1.jpeg', name: 'codigo_barras_1.jpeg', addedAt: '2026-02-24T14:18:00.000Z' }],
    rawBarcode: '',
    expectedData: { gtin: '', lote: '', validade: '', serie: '', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-2',
    name: '2 - GS1-128 (rosa)',
    createdAt: '2026-02-24T14:18:00.000Z',
    updatedAt: '2026-02-24T14:18:00.000Z',
    photos: [{ id: 'photo-s2', dataUrl: '/barcode-samples/codigo_barras_2.jpeg', name: 'codigo_barras_2.jpeg', addedAt: '2026-02-24T14:18:00.000Z' }],
    rawBarcode: '(01)00643169979345(17)260319(10)228492893',
    expectedData: { gtin: '00643169979345', lote: '228492893', validade: '19/03/2026', serie: '', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-3',
    name: '3 - Two-Read com AI 240 (refCode)',
    createdAt: '2026-02-24T14:18:00.000Z',
    updatedAt: '2026-02-24T14:18:00.000Z',
    photos: [{ id: 'photo-s3', dataUrl: '/barcode-samples/codigo_barras_3.jpeg', name: 'codigo_barras_3.jpeg', addedAt: '2026-02-24T14:18:00.000Z' }],
    rawBarcode: '(240)EUP4020X(17)260319(10)228492893',
    expectedData: { gtin: '', lote: '228492893', validade: '19/03/2026', serie: '', dataProducao: '', melhorUso: '', quantidade: '', refCode: 'EUP4020X' },
  },
  {
    id: 'sample-4',
    name: '4 - DataMatrix (pequeno 2)',
    createdAt: '2026-02-24T14:18:00.000Z',
    updatedAt: '2026-02-24T14:18:00.000Z',
    photos: [{ id: 'photo-s4', dataUrl: '/barcode-samples/codigo_barras_4.jpeg', name: 'codigo_barras_4.jpeg', addedAt: '2026-02-24T14:18:00.000Z' }],
    rawBarcode: '',
    expectedData: { gtin: '', lote: '', validade: '', serie: '', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-5',
    name: '5 - Supraflex Cruz 2.00x08mm (FGTZ200008)',
    createdAt: '2026-02-24T14:19:00.000Z',
    updatedAt: '2026-02-24T14:19:00.000Z',
    photos: [{ id: 'photo-s5', dataUrl: '/barcode-samples/codigo_barras_5.jpeg', name: 'codigo_barras_5.jpeg', addedAt: '2026-02-24T14:19:00.000Z' }],
    rawBarcode: '(01)08904118388000(17)260131(10)S24TZADOAF(21)S24TZADOS200008017',
    expectedData: { gtin: '08904118388000', lote: 'S24TZADOAF', validade: '31/01/2026', serie: 'S24TZADOS200008017', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-6',
    name: '6 - Supraflex Cruz 2.25x08mm (FGTZ225008)',
    createdAt: '2026-02-24T14:19:00.000Z',
    updatedAt: '2026-02-24T14:19:00.000Z',
    photos: [{ id: 'photo-s6', dataUrl: '/barcode-samples/codigo_barras_6.jpeg', name: 'codigo_barras_6.jpeg', addedAt: '2026-02-24T14:19:00.000Z' }],
    rawBarcode: '(01)08904118388116(17)251231(10)S23TZBJVAE(21)S23TZBJVS225008019',
    expectedData: { gtin: '08904118388116', lote: 'S23TZBJVAE', validade: '31/12/2025', serie: 'S23TZBJVS225008019', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-7',
    name: '7 - Supraflex Cruz 4.00x12mm (FGTZ400012)',
    createdAt: '2026-02-24T14:19:00.000Z',
    updatedAt: '2026-02-24T14:19:00.000Z',
    photos: [{ id: 'photo-s7', dataUrl: '/barcode-samples/codigo_barras_7.jpeg', name: 'codigo_barras_7.jpeg', addedAt: '2026-02-24T14:19:00.000Z' }],
    rawBarcode: '(01)08904118388895(17)251130(10)S23TZBHTAE(21)S23TZBHTS400012009',
    expectedData: { gtin: '08904118388895', lote: 'S23TZBHTAE', validade: '30/11/2025', serie: 'S23TZBHTS400012009', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-8',
    name: '8 - Supraflex Cruz 2.25x08mm SN028 (FGTZ225008)',
    createdAt: '2026-02-24T14:19:00.000Z',
    updatedAt: '2026-02-24T14:19:00.000Z',
    photos: [{ id: 'photo-s8', dataUrl: '/barcode-samples/codigo_barras_8.jpeg', name: 'codigo_barras_8.jpeg', addedAt: '2026-02-24T14:19:00.000Z' }],
    rawBarcode: '(01)08904118388116(17)251231(10)S23TZBJVAE(21)S23TZBJVS225008028',
    expectedData: { gtin: '08904118388116', lote: 'S23TZBJVAE', validade: '31/12/2025', serie: 'S23TZBJVS225008028', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
  {
    id: 'sample-9',
    name: '9 - Supraflex Cruz 2.00x28mm (FGTZ200028)',
    createdAt: '2026-02-24T14:19:00.000Z',
    updatedAt: '2026-02-24T14:19:00.000Z',
    photos: [{ id: 'photo-s9', dataUrl: '/barcode-samples/codigo_barras_9.jpeg', name: 'codigo_barras_9.jpeg', addedAt: '2026-02-24T14:19:00.000Z' }],
    rawBarcode: '(01)08904118388055(17)260731(10)S24TZAXGAX(21)S24TZAXGS200028046',
    expectedData: { gtin: '08904118388055', lote: 'S24TZAXGAX', validade: '31/07/2026', serie: 'S24TZAXGS200028046', dataProducao: '', melhorUso: '', quantidade: '', refCode: '' },
  },
];
